export declare const Type: FunctionConstructor;

export declare type Type<T> = new (...args: any[]) => T;
